export type TriageResolutionTab =
  | "suggestions"
  | "document"
  | "categorize"
  | "transactions";

export const TRIAGE_RESOLUTION_TAB_LABELS: Record<TriageResolutionTab, string> =
  {
    suggestions: "Suggestions",
    document: "Documents",
    categorize: "Accounts",
    transactions: "Transactions",
  };

/** Suggestion-option groups prepended into each tab's flat list (empty = catalog only). */
export const TRIAGE_TAB_GROUP_FILTERS: Record<TriageResolutionTab, string[]> = {
  suggestions: [],
  // Match tabs use filtered connections only — no AI recommendation prepend.
  document: [],
  categorize: [],
  transactions: [],
};

export const TRIAGE_TAB_CATALOG_CONFIG: Record<
  TriageResolutionTab,
  { searchPlaceholder: string }
> = {
  suggestions: {
    searchPlaceholder: "Search suggestions",
  },
  document: {
    searchPlaceholder: "Search documents",
  },
  categorize: {
    searchPlaceholder: "Search accounts",
  },
  transactions: {
    searchPlaceholder: "Search transactions",
  },
};

/** Option key for the first document or category recommendation. */
export function firstRecommendationOptionKey(triage: {
  suggestions?: Array<{
    identifier?: string | null;
    job?: string | null;
    lines?: Array<unknown> | null;
    ruleSuggestionDocumentOptions?: Array<{
      document?: { identifier?: string | null } | null;
    } | null> | null;
    ruleSuggestionChartedAccountOption?: {
      chartedAccount?: { identifier?: string | null } | null;
    } | null;
  } | null> | null;
}): string | null {
  const suggestions = triage.suggestions ?? [];
  const firstLinesSuggestion = suggestions.find(
    (suggestion) => (suggestion?.lines?.length ?? 0) > 0,
  );
  if (firstLinesSuggestion?.identifier) {
    return `lines:${firstLinesSuggestion.identifier}`;
  }
  const firstDocument = suggestions.find(
    (suggestion) => suggestion?.job === "MATCH_DOCUMENT",
  )?.ruleSuggestionDocumentOptions?.[0]?.document?.identifier;
  if (firstDocument) {
    return `document:${firstDocument}`;
  }
  // The account it posts to: a category's is the account the category narrows.
  const firstCategoryAccount = suggestions.find(
    (suggestion) => suggestion?.job === "CATEGORIZE",
  )?.ruleSuggestionChartedAccountOption?.chartedAccount?.identifier;
  if (firstCategoryAccount) {
    return `account:${firstCategoryAccount}`;
  }
  return null;
}
